import { DatePicker } from 'antd';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './commentListDateRangeModal.scss';

export default function DateRangeModal() {
    const [value, setValue] = useState([]);

    const pickerRef = useRef();
    const location = useLocation();

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const start = query.get('start');
        const end = query.get('end');
        if (start && end) {
            setValue([start, end]);
        } else {
            setValue([]);
        }
    }, []);

    const onChange = (date, time) => {
        window?.external?.DispatchFun?.(
            'HDC',
            'submitDateRange',
            JSON.stringify({ value })
        );
    };

    return (
        <div className="comeent-list-date-range-modal" ref={pickerRef}>
            <DatePicker.RangePicker
                className="comment-list-date-range-picker"
                popupClassName="comment-list-data-range-picker-popup"
                suffixIcon={
                    <i className={`icon-arrow-down outlined down-icon`} />
                }
                getPopupContainer={() => pickerRef.current}
                bordered={false}
                onChange={onChange}
                open={true}
                size="small"
                separator="~"
                value={value}
            />
        </div>
    );
}
